/**
 * Domain-based routing utility
 * Automatically routes users based on the domain they access
 */

export const getDomainType = () => {
    const hostname = window.location.hostname;

    // For local development
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        // Check if URL has /beach or /river path to determine which site
        const path = window.location.pathname;
        if (path.startsWith('/beach')) return 'beach';
        if (path.startsWith('/river')) return 'river';
        return 'main';
    }

    // Production domain detection
    if (hostname.includes('muthumuniayurvedabeach')) {
        return 'beach';
    }

    if (hostname.includes('muthumuniayurvedariver')) {
        return 'river';
    }

    // Default to main site (muthumuniayurvedaresorts.com)
    return 'main';
};

export const getBasePath = () => {
    const domainType = getDomainType();

    switch (domainType) {
        case 'beach':
            return '/beach';
        case 'river':
            return '/river';
        case 'main':
        default:
            return '/';
    }
};

export const shouldRedirectToDomain = () => {
    const hostname = window.location.hostname;
    const path = window.location.pathname;

    // Only redirect in production
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return null;
    }

    // If on main domain but accessing beach/river routes, redirect to respective domain
    if (hostname.includes('muthumuniayurvedaresorts.com')) {
        if (path.startsWith('/beach')) {
            return `https://muthumuniayurvedabeach.com${path.replace('/beach', '')}`;
        }
        if (path.startsWith('/river')) {
            return `https://muthumuniayurvedariver.com${path.replace('/river', '')}`;
        }
    }

    return null;
};
